import React from "react";
import Tutorregister from "./components/signupastutor/Tutorregister";
import Totalcal from "./components/signupastutor/Totalcal";
import TutorSignupWhyChoose from "./components/signupastutor/TutorSignupWhyChoose";
import Applayout from "../utils/layout/Applayout";
import Tutorapp from "./components/signupastutor/Tutorapp";
// import HowItWorks from "../frontendpages/components/home/HowItWorks";

const Becometutor = () => {
    return (
        
        <Applayout showFooter={true}>
            <Tutorregister/>
            <Totalcal/>
            <Tutorapp />
            <TutorSignupWhyChoose />
        </Applayout>
       
    )
}

export default Becometutor